<template>
  <div>
    <observer :observerUser="historyUser" :isHistory=true :myReport=true></observer>
  </div>
</template>

<script>
import observer from '@/components/custom/observer'
import apiClient2 from '@/services/axios/v2'
import { ToastFire } from '@/services/utilities/swal'
import store from 'store'
import { showErrorMessage } from '@/services/utilities'

export default {
  name: 'observationsMyReport',
  components: {
    observer,
  },
  data() {
    return {
      historyUser: {},
    }
  },
  created() {
    this.getHistory()
  },
  methods: {
    getHistory() {
      const userLocalStorage = JSON.parse(store.get('userData'))
      apiClient2.get(`/observations/users/${userLocalStorage.id}`).then(response => {
        this.historyUser = response.data.data
      }).catch(error => {
        ToastFire('warning', showErrorMessage(error))
        this.$router.go(-1)
      })
    },
  },
}
</script>

<style>
.ql-snow .ql-tooltip::before {
content: 'Marcar link' !important;
}
.ql-snow .ql-tooltip.ql-editing a.ql-action::after{
  content: 'Guardar' !important;
}
</style>
